import React from "react";
import "./InviteStaff.css";
import FadeUp from "../FadeUp/FadeUp";

const InviteStaff = ({ isAlbanian }) => {
  return (
    <div>
      <div className="invitestaff-container">
        <div className="overlay">
          <div className="vertical-line left"></div>
          <div className="vertical-line right"></div>
          <div className="invitestaff-content">
         
            <div
              className="invitestaff-right"
            >
              <a
                href="/listedjobs"
                rel="noopener noreferrer"
                style={{
                  textDecoration: "none",
                  color: "inherit",
                  display: "block",
                }}
                onContextMenu={(e) => e.stopPropagation()}
              >
                <FadeUp>
                <div className="invitestaff-card">
                  <div className="invitestaff-card-background">""</div>
                  <div className="invitestaff-card-content">
                  <h3>
  {isAlbanian 
    ? "Gjej vendin tënd në" 
    : "Find your place at"}<br />
  Vila-L Group
</h3>

                    <p>
                      {isAlbanian
                        ? "Bëhu pjesë e ekipit tonë. Mëso më shumë."
                        : "Be part of your Team. Learn more."}
                    </p>
                  </div>
                </div>
                </FadeUp>
              </a>
            </div>
           
          </div>
          <div className="bottom-line"></div>
        </div>
      </div>
    </div>
  );
};

export default InviteStaff;
